import { render, staticRenderFns } from "./Educacional.vue?vue&type=template&id=45466cfe&scoped=true&"
import script from "./Educacional.vue?vue&type=script&lang=js&"
export * from "./Educacional.vue?vue&type=script&lang=js&"
import style0 from "./Educacional.vue?vue&type=style&index=0&id=45466cfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45466cfe",
  null
  
)

export default component.exports